import { snakeCase } from 'lodash-es';
import {
  ACTIVITY,
  GROUP_ACTIVITY,
  POST
} from '../../../constants/FeedEntryTypes';

export const kudosUpdateEndpoint = ({ entity }) => {
  return entity === GROUP_ACTIVITY ? ACTIVITY : snakeCase(entity);
};

export const updateKudosData = ({
  entity,
  feedEntityState,
  entityId,
  parentEntityId,
  highlightedKudoser
}) => {
  let entryProps = null;
  if (entity === ACTIVITY) {
    entryProps = feedEntityState.props[entityId];
    entryProps.activity.kudosAndComments.canKudo = false;
    entryProps.activity.kudosAndComments.kudosCount += 1;
    entryProps.activity.kudosAndComments.highlightedKudosers = [
      highlightedKudoser
    ]
      .concat(entryProps.activity.kudosAndComments.highlightedKudosers)
      .slice(0, 3);
  } else if (entity === GROUP_ACTIVITY) {
    entryProps = feedEntityState.props[parentEntityId];

    entryProps.kudosAndComments[entityId].canKudo = false;
    entryProps.kudosAndComments[entityId].kudosCount += 1;
    entryProps.kudosAndComments[entityId].highlightedKudosers = [
      highlightedKudoser
    ]
      .concat(entryProps.kudosAndComments[entityId].highlightedKudosers)
      .slice(0, 3);
  } else if (entity === POST) {
    entryProps = feedEntityState.props[entityId];
    entryProps.post.can_kudo = false;
    entryProps.post.kudos_count += 1;
    entryProps.post.highlighted_kudosers = [highlightedKudoser]
      .concat(entryProps.post.highlighted_kudosers)
      .slice(0, 3);
  }
  return entryProps;
};
